import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CrossSellingComponent } from './cross-selling/cross-selling.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [CrossSellingComponent],
  exports: [],
  imports: [CommonModule, SharedModule],
})
export class CrossSellingModule {}
